// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/about_page_bg.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-page-topbg {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: 100% 25%;
    z-index: -1;
}

.about-page-content {
    font-family: Mulish;
    margin-top: max(80vh, 200px); /*Background*/
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    column-gap: 80px;
    row-gap: 100px;
    padding: 50px max(15px, 7%);
    min-height: 100%;
    position:relative;
    background-color: white;
    line-height: 1.5;
}


.about-page-content h1, .about-page-content h2, .about-page-content h3 {
    font-family: var(--displayFont);
    padding: 0;
    margin: 0;
}
.about-page-content h1 {
    font-weight: 800;
    font-size: 50px;
    margin-bottom: 10px;
}

.about-page-content h2 {
    font-size: 30px;
    font-weight: 800;
}

.about-page-content h3 {
    font-size: 20px;
    font-weight: 800;
}

.about-section p {
    font-size: 16px;
    font-weight: 400;
    margin: 0;
    padding: 0;
    margin-bottom: 20px;
}

.about-left-content {
    width: 50%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    row-gap: 80px;
}

.about-right-content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.contact-form {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 20px 40px;
    background-color: rgba(255, 255, 255, 0.894);
    -webkit-backdrop-filter: blur(40px);
            backdrop-filter: blur(40px);
    box-sizing: border-box;
    border: 1px solid #00000020;
    border-radius: 7px;
    margin-bottom: 20px;
    height: -moz-fit-content;
    height: fit-content;
    gap: 20px;
}

.topic-selector {
    display: flex;
    flex-direction: column;
    gap: 5px;
    font-size: 16px;
}
.topic-option {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    width: -moz-fit-content;
    width: fit-content;
}

.faq-container {
    width: 100%;
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
}`, "",{"version":3,"sources":["webpack://./src/styles/about/AboutPage.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,yDAAwD;IACxD,sBAAsB;IACtB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,4BAA4B,EAAE,aAAa;IAC3C,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,2BAA2B;IAC3B,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;AACpB;;;AAGA;IACI,+BAA+B;IAC/B,UAAU;IACV,SAAS;AACb;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,4CAA4C;IAC5C,mCAA2B;YAA3B,2BAA2B;IAC3B,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;IACnB,wBAAmB;IAAnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb","sourcesContent":[".about-page-topbg {\n    width: 100vw;\n    height: 100vh;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    background-image: url('../../assets/about_page_bg.jpeg');\n    background-size: cover;\n    background-position: 100% 25%;\n    z-index: -1;\n}\n\n.about-page-content {\n    font-family: Mulish;\n    margin-top: max(80vh, 200px); /*Background*/\n    display: flex;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n    column-gap: 80px;\n    row-gap: 100px;\n    padding: 50px max(15px, 7%);\n    min-height: 100%;\n    position:relative;\n    background-color: white;\n    line-height: 1.5;\n}\n\n\n.about-page-content h1, .about-page-content h2, .about-page-content h3 {\n    font-family: var(--displayFont);\n    padding: 0;\n    margin: 0;\n}\n.about-page-content h1 {\n    font-weight: 800;\n    font-size: 50px;\n    margin-bottom: 10px;\n}\n\n.about-page-content h2 {\n    font-size: 30px;\n    font-weight: 800;\n}\n\n.about-page-content h3 {\n    font-size: 20px;\n    font-weight: 800;\n}\n\n.about-section p {\n    font-size: 16px;\n    font-weight: 400;\n    margin: 0;\n    padding: 0;\n    margin-bottom: 20px;\n}\n\n.about-left-content {\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    row-gap: 80px;\n}\n\n.about-right-content {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n.contact-form {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    padding: 20px 40px;\n    background-color: rgba(255, 255, 255, 0.894);\n    backdrop-filter: blur(40px);\n    box-sizing: border-box;\n    border: 1px solid #00000020;\n    border-radius: 7px;\n    margin-bottom: 20px;\n    height: fit-content;\n    gap: 20px;\n}\n\n.topic-selector {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    font-size: 16px;\n}\n.topic-option {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    cursor: pointer;\n    width: fit-content;\n}\n\n.faq-container {\n    width: 100%;\n    margin: 20px 0;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
